import { render } from "./GitlabLogin.vue?vue&type=template&id=796d8804&scoped=true"
import script from "./GitlabLogin.vue?vue&type=script&lang=js"
export * from "./GitlabLogin.vue?vue&type=script&lang=js"

import "./GitlabLogin.vue?vue&type=style&index=0&id=796d8804&lang=scss&scoped=true"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796d8804"]])

export default __exports__